import React from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { ReactComponent as WorknestLogo } from "../images/myWorkNest_Purple_Positive_RGB.svg";
import GoogleLoginButton from "../components/GoogleLoginButton";
import layoutConstants from "../constants/layoutConstants";
import MicrosoftLoginButton from "../components/MicrosoftLoginButton";

const circlesImgUrl = `${process.env.PUBLIC_URL}/images/circles_bottom_left_purple.svg`;

const useStyles = makeStyles((theme) => ({
  grid: {
    height: "100vh",
    padding: theme.spacing(2),
    position: "relative",
    overflow: "hidden",
  },
  logoWrapper: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(2),
    maxWidth: layoutConstants.loginFormWidth,
  },
  logo: {
    width: "100%",
  },
  greeting: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  circles: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "40%",
    height: "auto",
    zIndex: 0,
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: layoutConstants.loginFormWidth,
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

function Login() {
  const classes = useStyles();

  return (
    <Grid
      className={classes.grid}
      container
      justifyContent="center"
      alignItems="center"
    >
      <img className={classes.circles} src={circlesImgUrl} />
      <Grid className={classes.formContainer} item xs={12} sm={6} xl={3}>
        <div className={classes.logoWrapper}>
          <WorknestLogo className={classes.logo} />
        </div>
        <Typography className={classes.greeting} variant="h3">
          Welcome
        </Typography>
        <div className={classes.buttons}>
          <MicrosoftLoginButton />
          <GoogleLoginButton />
        </div>
      </Grid>
    </Grid>
  );
}

export default Login;
